/**
 * Login Page
 * Azure Entra ID SSO login for BAFS employees
 */

import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

export default function Login() {
  const { login, isAuthenticated, isLoading } = useAuth();
  const navigate = useNavigate();

  // Redirect if already authenticated
  useEffect(() => {
    if (isAuthenticated) {
      navigate('/');
    }
  }, [isAuthenticated, navigate]);

  const handleLogin = async () => {
    await login();
  };

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-cream dark:bg-midnight">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-pond dark:border-pond-light mx-auto"></div>
          <p className="mt-4 text-slate dark:text-mist">Loading...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-cream dark:bg-midnight">
      <div className="max-w-md w-full space-y-8 p-8">
        {/* Logo/Header */}
        <div className="text-center">
          <h1 className="text-4xl font-bold text-pond dark:text-pond-light mb-2">
            Slope CRM
          </h1>
          <p className="text-lg text-slate dark:text-mirror">
            Business Alliance Financial Services, LLC
          </p>
        </div>

        {/* Login Card */}
        <div className="card">
          <div className="card-body space-y-6">
            <div className="text-center">
              <h2 className="text-2xl font-semibold text-slate dark:text-mist">
                Welcome Back
              </h2>
              <p className="mt-2 text-sm text-chalkboard dark:text-rain-cloud">
                Sign in with your BAFS User account
              </p>
            </div>

            {/* Sign in with Microsoft Button */}
            <button
              onClick={handleLogin}
              disabled={isLoading}
              className="w-full btn-primary flex items-center justify-center space-x-3"
            >
              <svg
                className="w-5 h-5"
                fill="currentColor"
                viewBox="0 0 23 23"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path d="M0 0h11v11H0zm12 0h11v11H12zM0 12h11v11H0zm12 0h11v11H12z" />
              </svg>
              <span>Sign in with Microsoft</span>
            </button>

            {/* Info */}
            <div className="pt-4 border-t border-gray dark:border-night-pond">
              <p className="text-xs text-center text-chalkboard dark:text-rain-cloud">
                This is a secure internal system for BAFS employees only.
                <br />
                You will be redirected to Microsoft to authenticate.
              </p>
            </div>
          </div>
        </div>

        {/* Footer */}
        <div className="text-center text-xs text-chalkboard dark:text-rain-cloud">
          <p>© {new Date().getFullYear()} Business Alliance Financial Services, LLC</p>
        </div>
      </div>
    </div>
  );
}
